import { TOAST } from '@commoncore/constants/ToastMessages';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { ListViewImplementation } from '@commoncore/implementation/ListViewImplementation';
import { IndexedDBModule } from '../../../../../mainrepo/src/app/core/database/IndexedDBManager';
import { PasswordEncryptorUtil } from '../../../../../mainrepo/src/app/core/utils/PasswordEncryptorUtil';

 export class ShareObjectsImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public numberregex = /^\d{10}$/;
  contextMenuService: any;
  mailError:any={"error":"","type":""};
  commentAlert:string= "";
  enableButton:boolean = false;
  items = [];
  splitPattern = new RegExp('[\,\;\ ]');
  comment:any;
  loggerService: any;
  globalService: any;
  receiverIds = [];
  public sharedFileRecipientsList:any;
  sharedWithNamesLink:any = "Not Shared yet";
  sharedWithMoreCountText:any;
  shareKey: any;
  shareLink: any;
  mailIds: any = [];
  shareMessage: any;
  commentMessage: any
  isLinkRestricted:boolean = true;
  shareType: any = "R";
  shareAccessRole: any = "V";
  isShareAccessRoleViewer: boolean = true;
  taggedRecieverAccessRole: any = "V";
  recipientList: any = [];
  contactChunk: any = [];
  contactNameChunk: any = [];
  selectedContact:any = [];
  currentTaggedContacts: any = [];
  modifiedRecipientsList = [];
  invalidEmailIDorNum: any = [];
  isAnyChange = false;
  isCopyLink: boolean = false;
  static singleInstance:any = null;
  changeDetector:any;
  albumFiles:boolean = false;
  inviteResp:any;
  db: IndexedDBModule;
  public fileOperationsImpl:any;
  fileOperation: any = "ManageShare";
  isFirstGetLink:boolean = false;
  listImpl:any;
  isInputValidated:boolean = false;
  displayList:any = [];

  //universal share link
  public passwordUtil:any;
  shareName:any = "";
  universalShareType:any = "L";
  shareExpiry:any = "";
  sharePassword:any = "";
  universalShareUrl:any = "";
  isShareNameUpdated:boolean = false;
  isSetExpiry:boolean = false;
  isChangePassword:boolean = false;
  localStorageService:any;
  //universal share link - End

  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.fileOperationsImpl= FileOperationsImplementation.getInstance(globalService);
    this.fileOperationsImpl.setHandler(globalService);
  }

  static getInstance(globalService):ShareObjectsImplementation{
    if(this.singleInstance == null){
      return new ShareObjectsImplementation(globalService)
    }else{
      return this.singleInstance
    }
  }

  public setHandler(globalService) {
    this.listImpl = ListViewImplementation.getInstance(globalService)
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.loggerService = globalService.getLoggerServiceRef();
    this.db = IndexedDBModule.getInstance(globalService);
    this.passwordUtil = new PasswordEncryptorUtil();
    this.localStorageService = globalService.getLocalStorageSvcRef();
  }


  setPayLoadForCreatingShareLink(files){
    var objectsArray = [];
    var payload = []
    if (Array.isArray(files)) {
      objectsArray = files
    } else {
      objectsArray.push(files)
    }
    
    objectsArray.map(obj=>{
      var object;
      if(obj["FullObject"]){
        object = obj["FullObject"]
      }else{
        object = obj
      }
      payload.push({
        "objectKey": object["objectKey"]
      })
    })
    return payload;
  }


  createShareLink(url,payload,albumFiles,albumKey){
    var params;
    var self = this;
      if(!albumFiles){
        params = {
            
            "objects":payload,
            "shareType":"P"
        }
    }else{
      params = {
        "boardKey":self.universalService.currentAlbum?self.universalService.currentAlbum["boardKey"]:albumKey,
        "objects":payload,
        "shareType":"P"
    }
    }
    return new Promise(function(resolve,reject){
    self.http.post(url,params).subscribe(
        shareLink=>{
            self.loggerService.log("shareLink is",shareLink);
            resolve(shareLink["shareURL"])
        },
        err=>{
            self.universalService.showLoader = false;
            self.loggerService.log("error in creating share link",err);
            reject(err);
        }
    )
    })
  }



  sendEmail(url,mailIds,shareURL){
    var params = {};
    if(this.universalService.showEnhancedShareLink == true) {
      params = {
        "recipients":mailIds,
        "shareKey":shareURL.split('?u=')[1]
      }
    } else {
      params = {
        "comments":this.comment,
        "recipients":mailIds,
        "shareKey":shareURL.split("?t=")[1].split("&s=")[0],
        "shareURL":shareURL
      }
    }
    
    var self = this;
    return new Promise(function(resolve,reject){
        self.http.post(url,params).subscribe(
            email=>{
                self.loggerService.log("response after sending email is==>",email);
                resolve(email)
            },
            err=>{
              self.loggerService.log("error in sending email is==>",err);
              reject(err)
            },
            complete=>{
              self.comment = "";
            }
        )
    })
  }
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }



  onItemRemoved(event){
    
    var a = this.invalidEmailIDorNum.indexOf(event)
    if(a>-1){
      this.invalidEmailIDorNum.splice(a,1)
    }
    if(this.invalidEmailIDorNum.length == 0 ){
      this.mailError.error = "";
    }
    this.loggerService.log('item being removed',event,this.receiverIds);
    // this.validateEmailId(this.receiverIds);
    this.validateInputIds(this.receiverIds, true);
    if(this.receiverIds.length == 0){
      this.commentAlert = "";
      this.mailError.error = ""
    }
  }

  onItemAdded(event){

    this.loggerService.log('item being added',this.receiverIds);
    for(var i=0;i<this.receiverIds.length;i++){
      this.receiverIds[i] = this.receiverIds[i].toLowerCase();
    }
    var unique = this.receiverIds.filter(this.onlyUnique);
    this.receiverIds = unique;
    
    this.validateInputIds(this.receiverIds);
    if(!this.universalService.isAnyChange) {
      var index = this.receiverIds.indexOf(mail=>mail.value == event.value ) 
      if(index){
        //this.receiverIds.splice(index,1);
        setTimeout(()=>{
          this.validateInputIds(this.receiverIds);
        },300)
        this.loggerService.log("after splicing invalid email")
      }
    }
  }

  async validateInputIds(items, isItemRemove=false) {
    var idsArray = [];
    this.currentTaggedContacts = items;
    if(items.length == 0) {
      this.prepareSelectedContact(items, isItemRemove);
    }

    for(var i=0; i < items.length; i++) {
      if(items[i] != "") {
        // if(isNaN(items[i])) {
          items[i] = items[i].toLowerCase();
          if(items[i].match(this.emailregex) && items[i].length <= 100) {
            if(items.length == 1) {
              this.mailError.error = "";
              this.universalService.isAnyChange = true;
              this.invalidEmailIDorNum = [];
            }
            idsArray.push(items[i]);
            this.prepareSelectedContact(items[i], isItemRemove);
            this.universalService.isAnyChange = true;
            this.isInputValidated = true;
            //var elm = document.getElementById("emailIDs").children[0].children[0].children[i] as HTMLElement
            //elm.style.color = ""
          } else {
          if(!this.invalidEmailIDorNum.includes(items[i]) && !isItemRemove) this.invalidEmailIDorNum.push(items[i])
            //var elm = document.getElementById("emailIDs").children[0].children[0].children[i] as HTMLElement
            //elm.style.color = "red"
            this.mailError.error = "Enter valid email id";
            this.isInputValidated = false;
            if(this.selectedContact.length != 0) {
              this.universalService.isAnyChange = true;
            } else {
              this.universalService.isAnyChange = false;
            }
          }
        // } else {
        //   if(items[i].match(this.numberregex)) {
        //     let res = await this.checkIfEntPrivateShare();
        //     if(res == true){
        //       return
        //     }
        //     if(items.length == 1) {
        //       this.mailError.error = "";
        //       this.universalService.isAnyChange = true;
        //       this.isInputValidated = true;
        //       this.invalidEmailIDorNum = [];
        //     }
        //     idsArray.push(items[i]);
        //     this.prepareSelectedContact(items[i], isItemRemove);
        //     //var elm = document.getElementById("emailIDs").children[0].children[0].children[i] as HTMLElement
        //     //elm.style.color = ""
        //     this.universalService.isAnyChange = true;
        //     this.isInputValidated = true;
        //   } else {
        //     let res = await this.checkIfEntPrivateShare();
        //     if(res == true){
        //       return
        //     }
        //     if(!this.invalidEmailIDorNum.includes(items[i]) && !isItemRemove) this.invalidEmailIDorNum.push(items[i])
        //     //var elm = document.getElementById("emailIDs").children[0].children[0].children[i] as HTMLElement
        //     //elm.style.color = "red"
        //     this.mailError.error = "Enter valid phone number";
        //     this.isInputValidated = false;
        //     if(this.selectedContact.length != 0) {
        //       this.universalService.isAnyChange = true;              
        //     } else {
        //       this.universalService.isAnyChange = false;
        //     }
        //   }
        // }
      }
    }
  }
  checkIfEntPrivateShare(){
    if( this.universalService.isAllowExtPrivateShare == true ||  this.universalService.isAllowEnternalPrivateShare == true){
      this.mailError.error = "Enter valid email id";
      this.toggleSmallLoader(false);
      this.isInputValidated = false;
      if(this.selectedContact.length != 0) {
        this.universalService.isAnyChange = true;              
      } else {
        this.universalService.isAnyChange = false;
      }
      return true;
    }else{
      return false;
    }
  }

  validateMobileNumber(items){
    var idsArray = []
    items.map(phonenumber=>{
      if(phonenumber.match(this.numberregex)){
        idsArray.push(phonenumber)
      }
    })
    if(idsArray.length != items.length){
      this.mailError.error = "Enter valid phone number"
      this.universalService.isAnyChange = false;
    }else {
      this.mailError.error = "";
      this.universalService.isAnyChange = true;
    }
  }


  validateEmailId(items){
    var idsArray = []
    items.map(email=>{
      email = email.toLowerCase();
      if(email.match(this.emailregex)){
        idsArray.push(email)
      }
    })
    if(idsArray.length != items.length){
      this.mailError.error = "Enter valid email id"
      this.universalService.isAnyChange = false;
    }else {
      this.mailError.error = "";
      this.universalService.isAnyChange = true;
    }
  }

  validateComments(comment){
    if(comment.length >= 180){
      if(comment.length > 200){
        this.commentAlert = "Message length exceeds maximum permitted."
        this.universalService.isAnyChange = false;
      }else if(comment.length == 200){
        this.commentAlert = "";
        this.universalService.isAnyChange = true;
      }else{
        this.commentAlert = (200-comment.length) + " characters remaining."
        this.universalService.isAnyChange = true;
      } 
    }else{
      this.commentAlert = "";
      this.universalService.isAnyChange = true;
    }
    this.comment = comment;
  }

  validateCollabShareObject(name) {
    if(name != undefined && name != "") {
      var index = this.universalService.collabShareObject.indexOf(name);
      if(index !== -1) {
        this.universalService.collabShareObject.splice(index, 1);
      } else {
        this.universalService.collabShareObject.push(name);
      }
    }

    if(this.universalService.collabShareObject.length == 0 && this.selectedContact.length == 0 && this.modifiedRecipientsList.length == 0) {
      this.universalService.isAnyChange = false;
    } else {
      this.universalService.isAnyChange = true;
    }
  }

   isCollabShareLinkPresent() {
     var currentObject = this.universalService.selectedFile;
     if (currentObject != undefined) {
       if (currentObject.shareLink == undefined && currentObject.shareKey == undefined) {
         return false;
       } else {
         return true;
       }
     }
     return false;
   }


   setPayLoadForCreatingCollabShareLink(file) {
     if(file == undefined) {
       return false;
     }
     var payload = {};
     if(this.isCopyLink && this.isFirstGetLink) { // if GetLink is from file options
      payload = {
        "objectKey": file.objectKey,
        "shareType": (file.shareType == undefined) ? "P" : file.shareType
      }
    } else if(this.isCopyLink) { // if GetLink is from Manage share
        payload = {
          "objectKey": file.objectKey,
          "shareType": this.shareType
        }
     } else {
        payload = {
          "objectKey": file.objectKey,
          "shareType": this.shareType
        };
  
        if (this.shareType != "") {
          payload["shareType"] = this.shareType;
        }
  
        if (this.shareType == "P") {
          payload["shareAccessRole"] = this.shareAccessRole;
        }
  
        if (this.selectedContact.length != 0) {
          if (this.shareMessage != "") {
            payload["shareMessage"] = this.shareMessage.replace(/\./g, '. ') //if url pattern is there, adding space to stop.;
          }
          payload["shareRecipients"] = this.selectedContact;
        }
     }

     return payload;
   }


   createCollabShareLink(url, payload) {
     var params = payload;
     var self = this;

     return new Promise(function (resolve, reject) {
       self.http.post(url, params).subscribe(
         response => {
           self.loggerService.log("response is", response);
           resolve(response);
         },
         err => {
           self.loggerService.log("error in creating collab share link", err);
           self.universalService.showErrorMessage(err);
           self.universalService.isServerError = false;
           reject(err);
         }
       )
     })
   }


   setPayLoadForUpdatingCollabShareLink() {
    var classRef = this;
    var payload = {};
    var file = classRef.universalService.selectedFile;
    
    if(this.isCopyLink) {
      if(this.universalService.collabShareObject.length > 0) {
        payload = {
          "objectKey" : file.objectKey,
          "shareKey" : classRef.shareKey,
          "objectType": file.objectType
        };
  
        if(this.shareType != "") {
          payload["shareType"] = this.shareType;
        }
  
        if(this.shareType == "P") {
          payload["shareAccessRole"] = this.shareAccessRole;
        }
      } else {
        payload = {
          "objectKey": file.objectKey,
          "shareType": (file.shareType == undefined) ? "R" : file.shareType,
          "shareKey" : classRef.shareKey,
          "objectType": file.objectType
        }
      }
   } else {
      payload = {
        "objectKey" : file.objectKey,
        "shareKey" : classRef.shareKey,
        "objectType": file.objectType
      };

      if(this.shareType != "") {
        payload["shareType"] = this.shareType;
      }

      if(this.shareType == "P") {
        payload["shareAccessRole"] = this.shareAccessRole;
      }

      if(this.selectedContact.length != 0) {
        if(this.shareMessage != "") {
          payload["shareMessage"] = this.shareMessage.replace(/\./g, '. ') //if url pattern is there, adding space to stop.;
        }
        payload["shareRecipients"] = this.selectedContact;
      }
    }

    return payload;
  }

  updateCollabShareLink(url, payload) {
    var params = payload;
     var self = this;

     return new Promise(function (resolve, reject) {
       self.http.put(url, params).subscribe(
         response => {
           self.loggerService.log("shareLink is", response);
           resolve(response)
         },
         err => {
           self.loggerService.log("error in creating collab share link", err);
           self.universalService.showErrorMessage(err);
           self.universalService.isServerError = false;
           reject(err);
         }
       )
     });
  }


  /**
   * Get members of file
  */
   getSharedFileMembers(url) {
     var self = this;

     return new Promise(function (resolve, reject) {
       self.http.get(url).subscribe(
         response => {
           self.loggerService.log("get member is");
           resolve(response)
         },
         err => {
           self.loggerService.log("error in getting member list", err);
           self.universalService.showErrorMessage(err);
           self.universalService.isServerError = false;
           reject(err);
         }
       )
     });
  }

  setMembersLink(suc) {
    var self = this;
    this.sharedFileRecipientsList = [];
    self.sharedWithNamesLink = "Not Shared yet";
    self.sharedWithMoreCountText = "";
    var namesToShowCount = 2;
    self.universalService.showLoader = false;
    self.sharedFileRecipientsList = suc["shareRecipients"].filter(function (recipient) { // Filter data, ignore owner role 
      return recipient.recipientRole != 'O';
    });
    
    if(self.sharedFileRecipientsList && self.sharedFileRecipientsList.length > 0) {
      self.sharedWithNamesLink = "";
      if(self.sharedFileRecipientsList.length > namesToShowCount) {
        //this.sharedWithNamesLink = 

        self.sharedFileRecipientsList.map(function (object, index) {
          if(index < namesToShowCount) {
            if(index != 0) {
              self.sharedWithNamesLink += ", ";
            }
            self.sharedWithNamesLink += (((object.firstName != undefined) ? object.firstName : object.recipientId) + " " + ((object.lastName != undefined) ? object.lastName : "")).trim();
          }
        })
        if(self.sharedWithNamesLink.length>40){
          self.sharedWithNamesLink = self.sharedWithNamesLink.slice(0,40) + "..."
        }
        self.sharedWithMoreCountText = "& " + (self.sharedFileRecipientsList.length - namesToShowCount) + " more"
      } else {
        self.sharedFileRecipientsList.map(function (object, index) {
          if(index != 0)
          self.sharedWithNamesLink += ", ";
          self.sharedWithNamesLink += (((object.firstName != undefined) ? object.firstName : object.recipientId) + " " + ((object.lastName != undefined) ? object.lastName : "")).trim();
        })
        if(self.sharedWithNamesLink.length>40){
          self.sharedWithNamesLink = self.sharedWithNamesLink.slice(0,40) + "..."
        }
        // $('.go-to-manage-access').text(self.sharedWithNamesLink);
      }
    } else {
      if(self.sharedWithNamesLink.length>40){
        self.sharedWithNamesLink = self.sharedWithNamesLink.slice(0,40) + "..."
      }
      // $('.go-to-manage-access').text(self.sharedWithNamesLink);
    }
  }

  getUserContactsBySearchKey(url) {
    
    var self = this;
    return new Promise((resolve, reject) => {
      self.http.get(url)
      .subscribe(
         response =>{
          resolve(response);
        },
        error =>{
         console.log("error", error);
         reject(error)
      })

    }) 
  }

   isEmpty(obj) {
     for (var key in obj) {
       if (obj.hasOwnProperty(key))
         return false;
     }
     return true;
   }

  searchContactValidation(searchKey) {
    if (searchKey == undefined || searchKey.length < 2) {
      return false;
    }
    return true;
  }


  parseContacts(contacts, searchKey) {
    this.contactChunk = [];
    var contactsLen = contacts.length;

    for (var i = 0; i < contactsLen; i++) {
      this.parseSingleContact(contacts[i], searchKey);
    }

    return this.contactChunk;
  }


  parseSingleContact(contact: any, searchKey) {
    if (!contact.jcard || contact.jcard[1] == undefined) {
      return;
    }

    var jcard = JSON.parse(contact.jcard)[1];
    var contactFieldsLen = jcard.length;

    var singleContact = [];


    for (var j = 0; j < contactFieldsLen; j++) {
      var contactObj = jcard[j][0];
      contactObj = contactObj.toLowerCase();
      switch (contactObj) {
        case 'n':
          this.handleName(contact.contactid, jcard[j][3], searchKey);
        break;
        case 'tel':
          this.handleTelephone(contact.contactid, jcard[j][3], searchKey);
          break;
        case 'email':
          this.handleEmail(contact.contactid, jcard[j][3], searchKey);
          break;
        default:
          break;
      }
    }
  }

  handleTelephone(contactId, data, searchKey) {
    var data = data.match(/\d+/);
    if(data == null) {
      return false;
    }
    data = data[0];
    if(data.indexOf(searchKey) > -1) {
      if(data.length >= 10) {
        data = data.substring(data.length-10, data.length);
      }
      if(data.match(this.numberregex)) {
        data = {
          contactId : contactId,
          display : data
        }

        this.contactNameChunk.some(item=>{
          if(item.contactId == contactId) {
            data.firstName = item.fullName;
            return true;
          }
        });
        this.contactChunk.push(data);
      }
    }
  }

  handleEmail(contactId, data:any, searchKey) {
    if(data.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) {  
      data = {
        contactId : contactId,
        display : data
      }

      this.contactNameChunk.some(item=>{
        if(item.contactId == contactId) {
          data.firstName = item.fullName;
          return true;
        }
      });
      this.contactChunk.push(data);
    }
  }


  handleName(contactId, data, searchKey) {
    //commenting fullName logic as now we will handling everything using displayName
    var name = "";
    if (data[3]) {
      name += data[3];
    }

    if (data[1]) {
      name += " " + data[1];
    }

    if (data[2]) {
      name += " " + data[2];
    }

    if (data[0]) {
      name += " " + data[0];
    }

    if (data[4]) {
      name += " " + data[4];
    }

    if (name && name.length > 0) {
      name = name.trim();
    }

    if(name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) {  
      data = {
        contactId : contactId,
        fullName : name
      }
      this.contactNameChunk.push(data);
    }
  }

  prepareSelectedContact(recieverId, isItemRemove) {
    if(isItemRemove) {
      this.contactChunk = [];
      for(var i =0; i < this.selectedContact.length; i++) {
        var ele = this.currentTaggedContacts.some(item=> {
          if(item == this.selectedContact[i].recipientId) {
            return true;
          }
        });
        if(!ele) {
          this.selectedContact.splice(i,1);
        }
      }
      this.validateCollabShareObject("");
    } else {
      for(var i =0; i < this.selectedContact.length; i++) {
        if(recieverId == this.selectedContact[i].recipientId) {
          return true;
        }
      }
      if(this.contactChunk.length == 0) {
        var data = {
          "recipientId": recieverId,
          "operation": "A"
        };
        this.selectedContact.push(data);
        this.validateCollabShareObject("");
        return true;
      }
      this.contactChunk.some(item => {
        if (item.display == recieverId) {
          var data = {
            "recipientId": recieverId,
            "operation": "A"
          };
    
          if(item.contactId != "") {
            data["contactId"] = item.contactId;
          }
    
          if(item.firstName != undefined && item.firstName != "") {
            data["firstName"] = item.firstName;
          }
          this.selectedContact.push(data);
          this.validateCollabShareObject("");
          this.contactChunk = [];
          return true;
        }
      });
    }
  }

  toggleSmallLoader(state){
    if(state) {
      jQuery(".spinner_loader").show();
    } else {
      jQuery(".spinner_loader").hide();
    }
  }

  setShareObjects(apiResponse) {
    this.toggleSmallLoader(false);
    var selectedObjectKey;
    if(apiResponse != null) {
      
      this.shareLink = apiResponse.shareLink;
      this.shareKey = apiResponse.shareKey;
      this.universalService.selectedNodes.map(item => {
        var obj = item["FullObject"] ? item["FullObject"]:item;
        obj['shareKey'] = apiResponse.shareKey;
        obj['shareLink'] = apiResponse.shareLink;
        obj['isShared'] = apiResponse.isShared;
        obj['shareType'] = apiResponse.shareType;
        obj['recipientsObjRights'] = this.universalService.recipientsObjRights;
        if(obj['url']){
          var temp : String = obj['url'];
          var i = temp.indexOf('shareKey');
          if(i>-1) { //If not found(shareKey not present), don't append
            obj['url'] =  temp.substr(0,i+9) + apiResponse.shareKey;
          }
        }
        selectedObjectKey = obj.objectKey;
      });
      //Update in indexedDB for recent horizontal panel
      if(this.universalService.selectedFile.horizontalItem  == true &&  !this.universalService.inAppWebViewOpened) {
        this.db.bulkAdd('RecentFilesMetadata', this.universalService.recentFilesPreviewArray);
      }

      //Update in indexedDB
      if(this.universalService.selectedFile.objectType !='FR' && this.universalService.selectedFile.shareKey && !this.universalService.inAppWebViewOpened) {
        this.fileOperationsImpl.saveToIndexDB(this.fileOperation, this.fileOperationsImpl.getIndexDBStoresTobeUpdate(this.universalService.selectedFile), this.universalService.selectedFile);
      }
      var find = this.universalService.foldersArray.find(m=>m["objectKey"] == selectedObjectKey)
      if(find){
        var index = this.universalService.foldersArray.indexOf(find);  //find the index of object in the folders array
        if(index>=0){
          this.universalService.foldersArray[index]["shareKey"] = apiResponse.shareKey;
          this.universalService.foldersArray[index]['shareLink'] = apiResponse.shareLink;
          this.universalService.foldersArray[index]['isShared'] = apiResponse.isShared;
          this.universalService.foldersArray[index]['shareType'] = apiResponse.shareType;
          this.universalService.foldersArray[index]['recipientsObjRights'] = this.universalService.recipientsObjRights;
        }
      }
      if(this.universalService.inAppWebViewOpened) {
        this.universalService.selectedFile.shareKey = apiResponse.shareKey
        this.universalService.selectedFile.shareLink = apiResponse.shareLink
        this.universalService.selectedFile.isShared = apiResponse.isShared
        this.universalService.selectedFile.shareType = apiResponse.shareType
      }
      //this.setIconForShare();
      //Update in indexedDB
      if(this.universalService.selectedFile.objectType =='FR' && this.universalService.selectedFile.shareKey) {
        this.fileOperationsImpl.saveToIndexDB(this.fileOperation, this.fileOperationsImpl.getIndexDBStoresTobeUpdate(this.universalService.selectedFile), this.universalService.selectedFile);
      }
    } else {
      this.universalService.showToast(TOAST["GENERIC_ERROR"], "error")
      return;
    }
  }

  setIconForShare() {
    var executedTask = "SHAREPERMISSION";
    var view = localStorage.getItem('shareRepoShareViewType');
    if(view == "listView") {
      this.listImpl.updateOnlyTheUI(this.universalService.selectedNodes, executedTask);
    } else {
      var array = [];
      if(this.universalService.nameSort){
        array = this.universalService.sortByNameArray
      }else{
        array = this.universalService.sortByDateArray
      }
      this.fileOperationsImpl.updateOnlyTheUI(array, this.universalService.selectedNodes, executedTask);
    }
  }

  resetDefaultProperties() {
    this.universalService.collabShareObject = [];
    this.sharedWithNamesLink = "";
    this.sharedWithMoreCountText = "";
    this.commentAlert = "";
    this.receiverIds = [];
    this.shareMessage = "";
    this.commentMessage = "";
    this.shareKey = "";
    this.shareLink = "";
    this.isLinkRestricted = true;
    this.shareType = "R";
    this.shareAccessRole = "V";
    this.isShareAccessRoleViewer = true;
    this.taggedRecieverAccessRole = "V";
    this.modifiedRecipientsList = [];
    this.sharedFileRecipientsList = [];
    this.selectedContact = [];
    this.mailError.error = "";
    this.universalService.isAnyChange = false;
    this.sharedWithMoreCountText = "";
    this.invalidEmailIDorNum = [];
    this.isFirstGetLink = false;
    $('#contact-input').val('');
    this.displayList = [];
  }

  resetUniversalLinkProperties() {
    this.shareName = "";
    this.shareExpiry = "";
    this.sharePassword = "";
    this.isShareNameUpdated = false;
    this.isSetExpiry = false;
    this.isChangePassword = false;
    this.universalService.isAnyChange = false; 
    this.universalShareUrl = "";
    $('.name-error').removeClass('name-error-msg');
    $('.password-error').removeClass('pass-error-msg');
  }

  getInviteLink(url){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.post(url).subscribe(
        suc=>{
          self.inviteResp = suc
          resolve(suc)
        },err=>{
          console.log("error in creating invite link",err);
          reject(err);
        }
      )
    })
  }

  shareInviteLink(url,mailIds){
    var self = this;
    var payload = {
      "emailIds":mailIds,
      "inviteCode":this.inviteResp["inviteCode"],
      "inviteURL":this.inviteResp["inviteUrl"]
    }
    return new Promise(function(resolve,reject){
      self.http.post(url,payload).subscribe(
        suc=>{
          self.inviteResp = suc
          resolve(suc)
        },err=>{
          console.log("error in creating invite link",err);
          reject(err);
        }
      )
    })
  }

  /**
   * Universal Share Link code
   */

  setPayLoadForUniversalShareLink(files) {
    var objectsArray = [];
    var objects = [];
    var payload = {};
    if (Array.isArray(files)) {
      objectsArray = files
    } else {
      objectsArray.push(files)
    }
    
    objectsArray.map(obj=>{
      var object;
      if(obj["FullObject"]){
        object = obj["FullObject"]
      }else{
        object = obj
      }
      objects.push({
        "objectKey": object["objectKey"]
      })
    })
    payload = {
      "objects": objects,
      "shareName" : this.shareName,
      "shareType": this.universalShareType
    }
    if(this.isSetExpiry) {
      payload['expiryDate'] = this.shareExpiry;
    }
    if(this.isChangePassword) {
      var encryptedPass = this.passwordUtil.encryptShareLinkPassword(this.sharePassword);
      payload['password'] = encryptedPass;
    }
    return payload;
  }

  createUniversalShareLink(url, payload) {
    var params = payload;
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.post(url, params).subscribe(
        response => {
          resolve(response);
        },
        err => {
          self.universalService.showErrorMessage(err);
          self.universalService.isServerError = false;
          if(err["error"]["code"] == 'SSOM0127' || err["error"]["code"] == 'SSOM0120') { 
            reject({status:"failed",data:err["error"]});  
          } else if(err["error"]["code"] == 'SSOM0141'){
            self.universalService.showToast(TOAST["PUBLIC_SHARING_DISABLED"],"error");
            reject({status:"failed",data:err["error"]});  
          }else {
            self.universalService.showErrorMessage(err);
            reject({status:"failed",data:err["error"]["error"]});  
          }
        }
      )
    })
  }

  setPayLoadForUpdateUniversalShareLink() {
    var payload = {};
    if(this.isShareNameUpdated) {
      payload['shareName'] = this.shareName;
      payload['isShareNameUpdated'] = this.isShareNameUpdated;
    }
    if(this.isSetExpiry) {
      payload['expiryDate'] = this.shareExpiry;
      payload['isSetExpiry'] = this.isSetExpiry;
    }
    if(this.isChangePassword) {
      var encryptedPass = this.passwordUtil.encryptShareLinkPassword(this.sharePassword);
      if(this.sharePassword != ""){
        payload['password'] = encryptedPass;
      }
      payload['isChangePassword'] = this.isChangePassword;
    }
    return payload;
  }

  updateUniversalShareLink(url, payload) {
    var params = payload;
    var self = this;

    return new Promise(function (resolve, reject) {
      self.http.put(url, params).subscribe(
        response => {
          resolve({status:"success",data:response});
        },
        err => {
          self.universalService.showErrorMessage(err);
          self.universalService.isServerError = false;
          if(err["error"]["code"] == 'SSOM0127' || err["error"]["code"] == 'SSOM0120') {
            reject({status:"failed",data:err["error"]});  
          } else {
            reject({status:"failed",data:err["error"]["error"]});  
          }
        }
      )
    });
  }

  getUniversalShareLinkPassword(url) {
    var self = this;

    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        response => {
          resolve(response);
        },
        err => {
          //self.universalService.showErrorMessage(err);
          self.universalService.isServerError = false;
          reject(err);
        }
      )
    });
  }
   /**
    * Universal share link code - END
    */

}